import styled from '@emotion/styled';
import moment from 'moment';
import React from 'react';
import { UserCumulativeUsages } from '../../../../ReduxStorage/InstitutionUsage/types';
import { SubscriptionPlanType } from '../../../../ReduxStorage/SubscriptionPlans/constants';
import { UserDailyUsageData } from '../../../../ReduxStorage/UserSubscriptionPlans/constants';
import type { UserSubscriptionBillingPeriod } from '../../../../ReduxStorage/UserSubscriptionPlans/selectors';
import { Button } from '../../../components/Marketing/Button';
// import { FakeLink } from '../../../components/FakeLink';
// import { InstitutionUsageTable } from '../../../components/SubscriptionsHelper/InstitutionUsageTable/component';
import { UsageOverTimeChart } from '../../../components/SubscriptionsHelper/UsageOverTimeChart/component';
import { UsageProgress } from '../../../components/SubscriptionsHelper/UsageProgress/component';

const Heading = styled('div')({
  fontSize: 18,
  borderBottom: '1px solid #CACACA',
  fontWeight: 600,
  lineHeight: '35px',
  marginBottom: 20,
});

// const SubHeading = styled('div')({
//   fontSize: 16,
//   fontWeight: 600,
// });

const CTAContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: 20,
});

const LearnerUsageOverTimeContainer = styled('div')({
  padding: '14px 12px 34px 12px',
});

const LearnerUsageChartContainer = styled('div')({
  marginTop: 16,
});

// const LearnerUsageByInstitutionContainer = styled('div')({
//   marginTop: 40,
// });

// const FAKE_INSTITUTION_DATA = [
//   {
//     name: 'Australian Catholic University',
//     path: '/institution/acu',
//     courses: 10,
//     activeClasses: 100,
//     enrolmentsInActiveClasses: 250,
//   },
//   {
//     name: 'UNSW',
//     path: '/institution/unsw',
//     courses: 10,
//     activeClasses: 100,
//     enrolmentsInActiveClasses: 250,
//   },
//   {
//     name: 'Western Sydney University',
//     path: '/institution/wsu',
//     courses: 10,
//     activeClasses: 100,
//     enrolmentsInActiveClasses: 250,
//   },
//   {
//     name: 'UNSW Engineering',
//     path: '/institution/unsweng',
//     courses: 10,
//     activeClasses: 100,
//     enrolmentsInActiveClasses: 250,
//   },
// ];

export const UsageView = React.memo(
  ({
    planType,
    UsageLimitExceededBanner,
    dailyUsage,
    cumulativeUsages,
    educatorSeats,
    educatorLimit,
    learnerLimit,
    portalLimit,
    isOwner,
    billingPeriods,
    subscriptionId,
    portalCount,
    fetchDailyUsageData,
    changePlan,
  }: {
    planType: SubscriptionPlanType;
    UsageLimitExceededBanner: JSX.Element | null;
    dailyUsage: UserDailyUsageData[];
    cumulativeUsages: UserCumulativeUsages;
    educatorSeats: number;
    educatorLimit: number;
    learnerLimit: number;
    portalLimit: number | null;
    portalCount: number;
    isOwner: boolean;
    billingPeriods: Array<UserSubscriptionBillingPeriod>;
    subscriptionId: string;
    fetchDailyUsageData: (
      subscriptionId: string,
      fromDate: string,
      toDate: string
    ) => void;
    changePlan?: () => void;
  }) => {
    return (
      <div>
        <Heading>Account usage</Heading>
        {UsageLimitExceededBanner}
        {cumulativeUsages.length > 0 && (
          <UsageProgress
            label="Learner usage for current period"
            currentPeriodLabel={cumulativeUsages[0].billingCycleStart}
            usageResetLabel={cumulativeUsages[0].billingCycleEnd}
            value={cumulativeUsages.map((usage) => usage.numLearners)}
            max={learnerLimit}
          />
        )}
        <UsageProgress
          label="Educator seat"
          value={[educatorSeats]}
          max={educatorLimit}
        />
        {planType === 'custom' && (
          <UsageProgress
            label="Portal limit"
            value={[portalCount]}
            max={portalLimit}
          />
        )}
        {isOwner && changePlan && (
          <CTAContainer>
            <Button
              variant="legacy-cta-pink"
              action={{
                kind: 'on_click',
                value: changePlan,
              }}
            >
              Change plan
            </Button>
          </CTAContainer>
        )}
        <LearnerUsageOverTimeContainer>
          <LearnerUsageChartContainer>
            <UsageOverTimeChart
              title="Learner usage over time"
              data={dailyUsage.map((usage) => {
                return {
                  name: usage.date,
                  amount: usage.numLearners,
                };
              })}
              selectOptions={billingPeriods.map((billingPeriod) => {
                return {
                  label: `${moment(billingPeriod.billingCycleStart).format(
                    'DD MMM YYYY'
                  )} - ${moment(billingPeriod.billingCycleEnd).format(
                    'DD MMM YYYY'
                  )}`,
                  value: `${billingPeriod.billingCycleStart}/${billingPeriod.billingCycleEnd}`,
                };
              })}
              onChange={(billingPeriod) => {
                const [fromDate, toDate] = billingPeriod.split('/');
                fetchDailyUsageData(subscriptionId, fromDate, toDate);
              }}
            />
          </LearnerUsageChartContainer>
        </LearnerUsageOverTimeContainer>
        {/* Awaiting BUFF-5230 */}
        {/* <LearnerUsageByInstitutionContainer>
          <SubHeading>Learner usage by institution</SubHeading>
          <InstitutionUsageTable
            institutions={FAKE_INSTITUTION_DATA}
            Link={FakeLink}
          />
        </LearnerUsageByInstitutionContainer> */}
      </div>
    );
  }
);
